import type { FormikErrors, FormikTouched, FormikValues } from 'formik'
import { ErrorMessage, Field } from 'formik'
import { get } from 'lodash'
import type { ReactNode } from 'react'
import styles from './Checkbox.module.scss'

type CheckboxProps = {
  name: string
  label: ReactNode
  errors?: FormikErrors<FormikValues>
  touched?: FormikTouched<FormikValues>
}

/**
 * Formik-connected checkbox with label and error display.
 */
export const Checkbox = ({ name, label, errors, touched }: CheckboxProps) => {
  const hasError = Boolean(get(errors, name) && get(touched, name))
  const inputId = name
  const errorId = `${name}-error`

  return (
    <div>
      <label htmlFor={inputId} className={styles.option}>
        <Field
          type="checkbox"
          id={inputId}
          name={name}
          className={styles.input}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        />
        <span className={styles.optionLabel}>{label}</span>
      </label>
      <ErrorMessage name={name}>
        {(msg) => (
          <div id={errorId} className={styles.error} role="alert">
            {msg}
          </div>
        )}
      </ErrorMessage>
    </div>
  )
}
